<div class="generales">

  <div fxLayout="row" fxLayoutAlign="center stretch" >
  <mat-spinner class="cargando" *ngIf="cargando"></mat-spinner>
  </div>

  <div *ngIf="!cargando && validarColaboradores">
  <h1 class="titutlo">{{'SECCIONES.SUFRIERON_ACONTECIMIENTO_TRAUMATICO.TITULO' | translate}}</h1>

  <table mat-table [dataSource]="tablaSufrieron" class="mat-elevation-z8">

  <!-- NOMBRE COLABORADOR -->
  <ng-container matColumnDef="nombre">
    <th mat-header-cell *matHeaderCellDef> <h2>{{'SECCIONES.SUFRIERON_ACONTECIMIENTO_TRAUMATICO.NOMBRE_COLABORADOR' | translate}}</h2></th>
    <td mat-cell *matCellDef="let element"> <h3>{{element.NameUser}}</h3> </td>
  </ng-container>

  <!-- ACCIONES -->
  <!-- <ng-container matColumnDef="acciones">
    <th mat-header-cell *matHeaderCellDef> <h2>Acciones</h2> </th>
    <td mat-cell *matCellDef="let element">
      <div fxLayout="row" fxLayoutAlign="space-evenly center" >
        <button mat-mini-fab matTooltip="Ver encuesta" color="warn" aria-label="Ver encuesta">
            <mat-icon>visibility</mat-icon>
          </button>
          <button mat-mini-fab matTooltip="Descargar encuesta" color="warn" aria-label="Descargar encuesta">
              <mat-icon>cloud_download</mat-icon>
            </button>
      </div>
    </td>
  </ng-container> -->

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  </div>
  <div *ngIf="!cargando && !validarColaboradores" fxLayout="row" fxLayoutAlign="center center" class="validarColaboradores" >
  <img src="assets/images/norm35/NO ACONTECIMIENTO.png" alt="aprobado" class="aprobado">
  <p>{{'SECCIONES.SUFRIERON_ACONTECIMIENTO_TRAUMATICO.MENSAJE' | translate}}</p>
  </div>
  </div>
